import React from 'react';

import { SATHI_APP_URL } from '@/utils/constants/sathi';
import CustomNotification from '../../CustomNotification/CustomNotification';

interface SathiMigrationNotification {
  _id: string;
  content?: {
    migratedCount?: number;
    influencerCount?: number;
    profileImages?: string[];
    avatars?: string[];
  };
}

interface Props {
  open: boolean;
  onClose: () => void;
  notification: SathiMigrationNotification;
  onMarkAsRead: (notifications: SathiMigrationNotification[]) => void;
}

const SathiMigrationCompletedCustomNotification: React.FC<Props> = ({
  open,
  onClose,
  notification,
  onMarkAsRead,
}) => {
  const migratedCount = notification?.content?.migratedCount ?? notification?.content?.influencerCount ?? 0;
  const avatars = notification?.content?.profileImages ?? notification?.content?.avatars ?? [];

  const handleDismiss = () => {
    onMarkAsRead([notification]);
    onClose();
  };

  return (
    <CustomNotification
      open={open}
      onClose={onClose}
      title="Migration complete!"
      message={
        <p>
          We have successfully migrated <b className="font-medium">{migratedCount}</b> Influencers. The affiliate links
          and discount codes remain the same
        </p>
      }
      actionText="Go to SATHI"
      avatars={avatars}
      icon={<span aria-hidden="true">🎉</span>}
      autoHideDuration={6000}
      instantClose
      playSound
      handleClickCross={handleDismiss}
      onActionClick={() => {
        window.open(SATHI_APP_URL, '_blank', 'noopener,noreferrer');
        handleDismiss();
      }}
    />
  );
};

export default SathiMigrationCompletedCustomNotification;
